import { useLanguage } from "@/i18n";
import { Reveal, SectionHeader } from "@/components/Reveal";

export const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="process" className="py-24 sm:py-32 bg-midnight border-y border-hairline/60" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader eyebrow={t.process.eyebrow} title={t.process.title} />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">
          {t.process.steps.map((step, i) => (
            <Reveal key={i} delay={0.1 * i}>
              <div data-testid={`process-step-${i}`} className="relative">
                <span className="font-serif text-6xl sm:text-7xl font-semibold text-gold/15 select-none">
                  0{i + 1}
                </span>
                <div className="mt-4 h-px w-12 bg-gold/50" />
                <h3 className="mt-5 font-serif text-2xl font-semibold text-ivory">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
